(function () {
  function bind(nav) {
    var toggle = nav.querySelector('.th-training-filters__toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('th-training-filters--open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target) && nav.classList.contains('th-training-filters--open')) {
        nav.classList.remove('th-training-filters--open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function init() {
    document.querySelectorAll('.th-training-filters').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
